import { render, staticRenderFns } from "./teste-bi-1.vue?vue&type=template&id=34df5d0f&scoped=true"
import script from "./teste-bi-1.vue?vue&type=script&lang=js"
export * from "./teste-bi-1.vue?vue&type=script&lang=js"
import style0 from "./teste-bi-1.vue?vue&type=style&index=0&id=34df5d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34df5d0f",
  null
  
)

export default component.exports